"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyHasTranslation = void 0;
const keyHasTranslation = (key) => {
    const translation = __.trans(key);
    return translation && translation !== key;
};
exports.keyHasTranslation = keyHasTranslation;
